import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "tags-container" }
const _hoisted_4 = {
  key: 0,
  class: "add-tag-section"
}
const _hoisted_5 = { style: {"border":"1px solid #ccc","border-radius":"18px","margin-top":"16px","padding-top":"8px"} }
const _hoisted_6 = {
  slot: "content",
  class: "consultation-section"
}
const _hoisted_7 = { class: "consultation-inputs" }
const _hoisted_8 = { class: "datetime-inputs" }
const _hoisted_9 = {
  slot: "content",
  class: "previous-consultations"
}
const _hoisted_10 = {
  key: 0,
  style: {"padding":"4px 4px 0 4px"}
}
const _hoisted_11 = {
  key: 0,
  class: "spin"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { slot: "content" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { slot: "content" }
const _hoisted_25 = { slot: "content" }
const _hoisted_26 = {
  key: 2,
  class: "ion-padding"
}
const _hoisted_27 = { style: {"margin-top":"16px","margin-bottom":"24px"} }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = {
  class: "program-content",
  style: {"width":"100%","display":"flex","flex-direction":"column","gap":"4px","padding":"5px 0"}
}
const _hoisted_30 = { style: {"display":"flex","gap":"4px","align-items":"flex-start"} }
const _hoisted_31 = { style: {"flex":"1"} }
const _hoisted_32 = { style: {"margin":"0","font-size":"0.9em","line-height":"1.2"} }
const _hoisted_33 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_34 = { key: 4 }
const _hoisted_35 = {
  class: "program-content",
  style: {"width":"100%","display":"flex","flex-direction":"column","gap":"4px","padding":"5px 0"}
}
const _hoisted_36 = { style: {"display":"flex","gap":"4px","align-items":"flex-start"} }
const _hoisted_37 = { style: {"flex":"1"} }
const _hoisted_38 = { style: {"margin":"0","font-size":"0.9em","line-height":"1.2"} }
const _hoisted_39 = { style: {"display":"flex","gap":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_AB3DisciplineResultList = _resolveComponent("AB3DisciplineResultList")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_program_elective_requirements = _resolveComponent("program-elective-requirements")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_SubjectScoreInputSection = _resolveComponent("SubjectScoreInputSection")!
  const _component_ProgramItemContent = _resolveComponent("ProgramItemContent")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAB3ParentView)
      ? (_openBlock(), _createBlock(_component_page_header, {
          key: 0,
          isAB3ParentView: true
        }))
      : (_openBlock(), _createBlock(_component_ion_header, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, {
              class: "ion-no-padding",
              fixed: ""
            }, {
              default: _withCtx(() => [
                (!_ctx.isAB3ParentView && !_ctx.hideTitle)
                  ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                      default: _withCtx(() => [
                        (!_ctx.isDemo)
                          ? (_openBlock(), _createBlock(_component_ion_buttons, {
                              key: 0,
                              slot: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  slot: "icon-only",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelect()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_title, {
                          class: "ion-text-center",
                          style: {"padding-right":"0"}
                        }, {
                          default: _withCtx(() => [
                            (_ctx.targetUser)
                              ? (_openBlock(), _createBlock(_component_ion_label, {
                                  key: 0,
                                  class: "ion-text-wrap"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.schoolId == 'beacon1' ? 'Demo School' : _ctx.user.schoolId?.toUpperCase()), 1)
                                    ]),
                                    _createElementVNode("h2", null, [
                                      _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.user.class) + _toDisplayString(_ctx.formatStudentNumber(_ctx.user.studentNumber)), 513), [
                                        [_vShow, _ctx.user.class]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.user.fullName) + " ", 1),
                                      (_ctx.user.chineseName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.user.chineseName) + ")", 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.isAB3)
                                ? (_openBlock(), _createBlock(_component_ion_label, {
                                    key: 1,
                                    class: "ion-text-wrap"
                                  }, {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createElementVNode("h2", null, [
                                        _createElementVNode("b", null, "AB3")
                                      ], -1)
                                    ])),
                                    _: 1,
                                    __: [21]
                                  }))
                                : (_openBlock(), _createBlock(_component_ion_label, {
                                    key: 2,
                                    class: "ion-text-wrap"
                                  }, {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createElementVNode("h2", null, [
                                        _createElementVNode("b", null, "AchieveJUPAS 2.0 (Beta)")
                                      ], -1)
                                    ])),
                                    _: 1,
                                    __: [22]
                                  }))
                          ]),
                          _: 1
                        }),
                        (!_ctx.loading && !_ctx.isAB3)
                          ? (_openBlock(), _createBlock(_component_ion_buttons, {
                              key: 1,
                              slot: "end"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.targetUser)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUserProfileFormModal(_ctx.targetUser)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.pencil
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_ion_button, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: undefined
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isAB3)
                          ? (_openBlock(), _createBlock(_component_ion_buttons, {
                              key: 2,
                              slot: "end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openImageModal(_ctx.getProxyImgLink(`https://docs.google.com/presentation/d/1v8O0j-EYeGItQuS8N-lEj9qJQsV6oXOYtCG_y3x4F-U/export/jpeg?pageid=g2fa5c90539b_0_42`))))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.helpCircleOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isAB3)
                  ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                      key: 1,
                      style: {"--min-height":"32px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment, {
                          mode: "ios",
                          modelValue: _ctx.currStep,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currStep) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_segment_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createElementVNode("p", null, "1. Disciplines", -1)
                                  ])),
                                  _: 1,
                                  __: [23]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_segment_button, { value: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createElementVNode("p", null, "2. Programs", -1)
                                  ])),
                                  _: 1,
                                  __: [24]
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_segment_button, { value: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createElementVNode("p", null, "3. Electives", -1)
                                  ])),
                                  _: 1,
                                  __: [25]
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.electiveCombinations[_ctx.userRelatedSchool.id]]
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.targetUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_ion_toolbar, { class: "tags-section" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTagOptions(), (tag) => {
                              return (_openBlock(), _createBlock(_component_ion_chip, {
                                key: tag.id,
                                class: "small-chip",
                                outline: !_ctx.targetUser.tagIds.includes(tag.id),
                                onClick: ($event: any) => (_ctx.toggleTag(tag))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["outline", "onClick"]))
                            }), 128)),
                            (!_ctx.showAddTag)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  class: "add-tag-btn",
                                  size: "small",
                                  fill: "clear",
                                  onClick: _ctx.toggleAddTag
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.showAddTag)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_ion_item, {
                                  class: "add-tag-input",
                                  lines: "none"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.newTagName,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newTagName) = $event)),
                                      placeholder: "New tag",
                                      onKeyup: _withKeys(_ctx.addNewTag, ["enter"]),
                                      class: "small-input"
                                    }, null, 8, ["modelValue", "onKeyup"]),
                                    _createVNode(_component_ion_button, {
                                      slot: "end",
                                      size: "small",
                                      onClick: _ctx.addNewTag
                                    }, {
                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createTextVNode("Add")
                                      ])),
                                      _: 1,
                                      __: [26]
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_ion_button, {
                                      slot: "end",
                                      size: "small",
                                      fill: "clear",
                                      onClick: _ctx.toggleAddTag
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode("Cancel")
                                      ])),
                                      _: 1,
                                      __: [27]
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_ion_accordion_group, { value: "input" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_accordion, {
                              value: "input",
                              style: {"background":"transparent"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  slot: "header",
                                  style: {"--background":"transparent"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      class: "ion-text-wrap",
                                      style: {"color":"var(--ion-color-dark)"}
                                    }, {
                                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                                        _createTextVNode(" Next Consultation ")
                                      ])),
                                      _: 1,
                                      __: [28]
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_ion_input, {
                                        type: "date",
                                        modelValue: _ctx.nextConsultation.date,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nextConsultation.date) = $event)),
                                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleConsultationChange()))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_ion_input, {
                                        type: "time",
                                        modelValue: _ctx.nextConsultation.time,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nextConsultation.time) = $event)),
                                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleConsultationChange()))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_ion_input, {
                                        type: "text",
                                        modelValue: _ctx.nextConsultation.venue,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.nextConsultation.venue) = $event)),
                                        placeholder: "Venue",
                                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleConsultationChange()))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createVNode(_component_ion_accordion_group, { class: "compact-accordion" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_accordion, { value: "previous" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            slot: "header",
                                            lines: "none"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { style: {"color":"var(--ion-color-medium)"} }, {
                                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                  _createTextVNode("Previous Consultations")
                                                ])),
                                                _: 1,
                                                __: [29]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_9, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousConsultations, (consultation, index) => {
                                              return (_openBlock(), _createBlock(_component_ion_item, {
                                                key: index,
                                                lines: "none"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("h3", null, _toDisplayString(new Date(consultation.date).toLocaleDateString()), 1),
                                                      _createElementVNode("p", null, _toDisplayString(consultation.venue), 1),
                                                      _createElementVNode("p", null, _toDisplayString(consultation.notes), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.targetUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_ion_textarea, {
                                "label-placement": "floating",
                                label: "Any comments / remarks?",
                                fill: "outline",
                                rows: 1,
                                style: {"--padding-start":"12px"},
                                modelValue: _ctx.nextConsultation.remarks,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nextConsultation.remarks) = $event)),
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleConsultationChange()))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_button, {
                                class: "ion-text-left no-text-transform",
                                color: "medium",
                                fill: "clear",
                                size: "small",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sendRemarksToTargetStudent()))
                              }, {
                                default: _withCtx(() => [
                                  _cache[30] || (_cache[30] = _createTextVNode(" Send to student's WhatsApp group ")),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.send
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1,
                                __: [30]
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createBlock(_component_ion_grid, {
              key: 1,
              class: "ion-no-padding",
              fixed: ""
            }, {
              default: _withCtx(() => [
                (_ctx.isAB3ParentView)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      lines: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createElementVNode("h3", null, [
                              _createElementVNode("i", null, "The followings are chosen by your child / custodee at this moment:")
                            ], -1)
                          ])),
                          _: 1,
                          __: [31]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isAB3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("div", null, [
                        (_ctx.isAB3)
                          ? (_openBlock(), _createBlock(_component_AB3DisciplineResultList, {
                              key: 0,
                              onAddProgramToChoices: _ctx.addProgramToChoices,
                              onUnselectProgram: _ctx.unselectProgram,
                              onSelectedDisciplinesUpdated: _ctx.selectedDisciplinesUpdated,
                              selectedPrograms: _ctx.selectedPrograms,
                              readOnly: _ctx.isAB3ParentView
                            }, null, 8, ["onAddProgramToChoices", "onUnselectProgram", "onSelectedDisciplinesUpdated", "selectedPrograms", "readOnly"]))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.currStep == 1]
                      ]),
                      _withDirectives(_createVNode(_component_ion_accordion_group, {
                        modelValue: _ctx.expandedProgramIds,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.expandedProgramIds) = $event)),
                        multiple: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_reorder_group, {
                            onIonItemReorder: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onReorderProgram($event, _ctx.selectedPrograms))),
                            disabled: _ctx.isAB3ParentView ? true : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPrograms, (item, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_ion_accordion, {
                                    value: item.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        class: _normalizeClass(["choice-item", _ctx.getBandClass(idx)]),
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_reorder, {
                                            slot: "start",
                                            style: {"margin-inline-end":"8px"}
                                          }),
                                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", null, [
                                                _createElementVNode("b", null, _toDisplayString(_ctx.getBandLabel(idx)) + ".", 1),
                                                _cache[33] || (_cache[33] = _createTextVNode("  ")),
                                                (item.jupasUrl)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                      _cache[32] || (_cache[32] = _createTextVNode("[")),
                                                      _createElementVNode("a", {
                                                        href: item.jupasUrl,
                                                        target: "_blank"
                                                      }, _toDisplayString(item.jupasCode), 9, _hoisted_14),
                                                      _createTextVNode("] " + _toDisplayString(item.label), 1)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.displayName), 1))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (!_ctx.isAB3ParentView)
                                            ? (_openBlock(), _createBlock(_component_ion_buttons, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_button, {
                                                    onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenProgram(idx, item)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        size: "small",
                                                        slot: "icon-only",
                                                        icon: _ctx.trashOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_ion_list, {
                                        style: {"padding":"0 0 0 40px"},
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_program_elective_requirements, { item: item }, null, 8, ["item"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, _ctx.currStep == 2]
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_ion_accordion_group, {
                          multiple: true,
                          value: 0
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,-1,-2], (programId) => {
                              return _createVNode(_component_ion_accordion, {
                                key: programId,
                                value: programId,
                                style: {"--min-height":"24px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    lines: "full",
                                    slot: "header",
                                    color: "light"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, [
                                            _createElementVNode("p", null, _toDisplayString(_ctx.getElectiveChoiceLabel(programId)), 1)
                                          ]),
                                          (_ctx.getSelectedUserElectives(programId).length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                (_ctx.getPossibleClasses(programId).length > 0)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                                      _createTextVNode(" Possible class" + _toDisplayString(_ctx.getPossibleClasses(programId).length > 1 ? 'es' : '') + ": ", 1),
                                                      _createElementVNode("b", null, _toDisplayString(_ctx.getPossibleClasses(programId).join(" , ")), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("p", null, [
                                                  _cache[34] || (_cache[34] = _createTextVNode("Selected: ")),
                                                  _createElementVNode("b", null, _toDisplayString(_ctx.getElectiveShortNames(_ctx.getSelectedUserElectives(programId)).join(" , ")), 1)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_18, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4], (num) => {
                                      return _createVNode(_component_ion_item, {
                                        key: num,
                                        disabled: _ctx.isDisableElectiveSelect(programId, num)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_select, {
                                            label: num == 4 ? `Math Options` : `Elective ${num}`,
                                            "label-placement": "floating",
                                            interface: "popover",
                                            value: _ctx.getUserElective(programId, num, 'like', 'electiveId'),
                                            onIonChange: ($event: any) => (_ctx.onUpdateElectiveForProgram($event, programId, num))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableElectives(num, programId), (opt) => {
                                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                  key: opt.id,
                                                  value: opt.id,
                                                  disabled: opt.isGroup
                                                }, {
                                                  default: _withCtx(() => [
                                                    (opt.isGroup)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(opt.name) + "：", 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_20, "   " + _toDisplayString(opt.name), 1))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "disabled"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label", "value", "onIonChange"]),
                                          (_ctx.getSelectedUserElectives(programId, 4).length <= num && _ctx.getUserElective(programId, num, 'like', 'electiveId'))
                                            ? (_openBlock(), _createBlock(_component_ion_buttons, {
                                                key: 0,
                                                slot: "end"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_button, {
                                                    color: "medium",
                                                    onClick: _withModifiers(($event: any) => (_ctx.clearUserElectiveSelect(programId, num)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        size: "small",
                                                        slot: "start",
                                                        icon: _ctx.trashOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled"])
                                    }), 64))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        }),
                        (_ctx.userRelatedSchool.f3ClassChart)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              style: {"width":"100%"},
                              src: _ctx.getProxyImgLink(_ctx.userRelatedSchool.f3ClassChart),
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openImageModal(_ctx.getProxyImgLink(_ctx.userRelatedSchool.f3ClassChart))))
                            }, null, 8, _hoisted_21))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.currStep == 3]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (!_ctx.targetUser && _ctx.userRelatedSchool.achievejupasNeedParentConsent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_ctx.user.userConsentRecords?.find(r => r.target == 'achievejupas_parent_consent'))
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 0,
                                  lines: "none",
                                  button: "",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openParentConsentModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                                        _createElementVNode("h3", null, [
                                          _createElementVNode("b", null, "Parent Consent Obtained")
                                        ], -1)
                                      ])),
                                      _: 1,
                                      __: [35]
                                    }),
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: _ctx.checkmarkCircle,
                                      color: "success"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 1,
                                  lines: "none",
                                  color: "danger",
                                  button: "",
                                  detail: "",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openParentConsentModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                                        _createElementVNode("h3", null, [
                                          _createElementVNode("b", null, "Parent Consent Required!")
                                        ], -1),
                                        _createElementVNode("p", null, "To continue using AchieveJUPAS, we need your parent's or guardian's consent.", -1)
                                      ])),
                                      _: 1,
                                      __: [36]
                                    }),
                                    _createVNode(_component_ion_button, {
                                      class: "no-text-transform",
                                      slot: "end"
                                    }, {
                                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                                        _createTextVNode(" Start ")
                                      ])),
                                      _: 1,
                                      __: [37]
                                    })
                                  ]),
                                  _: 1
                                }))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        ((_ctx.user.isAdmin || Number(_ctx.user.yearDSE) >= _ctx.getF5YearDSE()) && (_ctx.userRelatedSchool.achievejupasDeadline1 || _ctx.userRelatedSchool.achievejupasDeadline2))
                          ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
                              key: 0,
                              value: "deadlines"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_accordion, { value: "deadlines" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      lines: "none"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                                            _createElementVNode("h3", null, "Deadlines", -1)
                                          ])),
                                          _: 1,
                                          __: [38]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_24, [
                                      (_ctx.userRelatedSchool.achievejupasDeadline1)
                                        ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, "Fill in A1 to A3 by " + _toDisplayString(_ctx.userRelatedSchool.achievejupasDeadline1), 1)
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.isFilledA1ToA3)
                                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                    key: 0,
                                                    slot: "end",
                                                    icon: _ctx.checkmarkCircle,
                                                    color: "success"
                                                  }, null, 8, ["icon"]))
                                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                                    key: 1,
                                                    slot: "end",
                                                    icon: _ctx.alertCircle,
                                                    color: "danger"
                                                  }, null, 8, ["icon"]))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.userRelatedSchool.achievejupasDeadline2)
                                        ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, "Fill in all 20 choices by " + _toDisplayString(_ctx.userRelatedSchool.achievejupasDeadline2), 1)
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.isFilled20Choices)
                                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                    key: 0,
                                                    slot: "end",
                                                    icon: _ctx.checkmarkCircle,
                                                    color: "success"
                                                  }, null, 8, ["icon"]))
                                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                                    key: 1,
                                                    slot: "end",
                                                    icon: _ctx.alertCircle,
                                                    color: "danger"
                                                  }, null, 8, ["icon"]))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.teacherComments.length > 0)
                          ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_accordion, { value: "comments" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      lines: "none"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h3", null, "Teacher Comments (" + _toDisplayString(_ctx.teacherComments.length) + ")", 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_25, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherComments, (c) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: c.id,
                                          lines: "none"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("p", null, [
                                                  _createElementVNode("small", null, "From " + _toDisplayString(c.fromUser.fullName) + " (" + _toDisplayString(_ctx.formatDate(c.createdAt)) + ")", 1)
                                                ]),
                                                _createElementVNode("h3", null, _toDisplayString(c.comment), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_ctx.user.isAdmin || _ctx.isDemo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[39] || (_cache[39] = [
                                _createElementVNode("small", null, "From Ms. Wong (2024/12/31 10:00)", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 中大有個人類學嘅Program，你可以考慮下 ")
                              ])))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ion_segment, {
                            color: "medium",
                            mode: "md",
                            scrollable: "",
                            modelValue: _ctx.selectedPlan,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedPlan) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_segment_button, {
                                class: "no-text-transform plan-segment-btn",
                                value: "Dec submission"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { style: {"color":"var(--ion-color-dark)"} }, {
                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                      _createTextVNode("Dec Submission")
                                    ])),
                                    _: 1,
                                    __: [40]
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['+ (Safety Net...)'], (plan) => {
                                return _createVNode(_component_ion_segment_button, {
                                  class: "no-text-transform plan-segment-btn",
                                  key: plan,
                                  value: plan,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { style: {"color":"var(--ion-color-medium)"} }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(plan), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", {
                            style: _normalizeStyle([{"margin":"8px 0"}, { 'margin-top': _ctx.targetUser ? 0 : '8px' }])
                          }, [
                            _createVNode(_component_SubjectScoreInputSection, {
                              targetUser: _ctx.targetUser,
                              title: _ctx.targetUser ? 'Student Prediction' : 'My Prediction',
                              source: "overallTarget",
                              passIcon: _ctx.ellipse,
                              hideSubjectNames: true,
                              readonly: !!_ctx.targetUser,
                              noBottomBorderRadius: true,
                              gradeSelectLargeFont: true
                            }, null, 8, ["targetUser", "title", "passIcon", "readonly"]),
                            _createVNode(_component_SubjectScoreInputSection, {
                              targetUser: _ctx.targetUser,
                              title: "School Prediction",
                              source: "schoolPredict",
                              passIcon: _ctx.star,
                              hideSubjectNames: false,
                              readonly: !_ctx.targetUser,
                              noTopBorderRadius: true,
                              gradeSelectLargeFont: true
                            }, null, 8, ["targetUser", "passIcon", "readonly"])
                          ], 4)
                        ]),
                        (_ctx.selectedPlan == 'Dec submission')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_ion_reorder_group, {
                                onIonItemReorder: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onReorderProgram($event, _ctx.selectedPrograms))),
                                disabled: _ctx.targetUser ? true : false
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPrograms, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                      key: item.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, {
                                          class: _normalizeClass(["choice-item", _ctx.getBandClass(idx)]),
                                          lines: "none",
                                          onClick: _withModifiers(($event: any) => (_ctx.openABProgramDeckModal(item.id, false, true)), ["stop"]),
                                          button: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ProgramItemContent, {
                                              item: item,
                                              idx: idx,
                                              allowDelete: !_ctx.targetUser,
                                              onClickedPenBtn: ($event: any) => (_ctx.openABProgramDeckModal(item.id, false, true)),
                                              onClickedTrashBtn: ($event: any) => (_ctx.onDeleteChosenProgram(idx, item)),
                                              hideDisciplineBadges: true,
                                              showRecommendedEvents: !_ctx.targetUser && item.id == 161,
                                              schoolPredictScoreIconColor: _ctx.getProgramScoreIconColor(item, 'schoolPredict'),
                                              targetScoreIconColor: _ctx.getProgramScoreIconColor(item, 'overallTarget')
                                            }, null, 8, ["item", "idx", "allowDelete", "onClickedPenBtn", "onClickedTrashBtn", "showRecommendedEvents", "schoolPredictScoreIconColor", "targetScoreIconColor"]),
                                            _createVNode(_component_ion_reorder, {
                                              slot: "end",
                                              style: {"margin-inline-start":"4px","margin-inline-end":"0"}
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "onClick"]),
                                        _createVNode(_component_ion_item_options, { side: "end" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_item_option, {
                                              color: "danger",
                                              onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenProgram(idx, item)), ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  slot: "icon-only",
                                                  icon: _ctx.trashOutline
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({length: 20 - _ctx.selectedPrograms.length}, (_, i) => i + _ctx.selectedPrograms.length), (idx) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: `empty-${idx}`,
                                  class: _normalizeClass(["choice-item", _ctx.getBandClass(idx)]),
                                  lines: "full",
                                  onClick: ($event: any) => (!_ctx.targetUser && idx == _ctx.selectedPrograms.length ? _ctx.openABProgramDeckModal(null, false, true) : undefined),
                                  disabled: _ctx.isDemo || (!_ctx.targetUser && idx == _ctx.selectedPrograms.length ? false : true),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("p", _hoisted_32, [
                                            _createElementVNode("b", null, _toDisplayString(_ctx.getBandLabel(idx)), 1)
                                          ])
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_33, [
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            fill: "clear",
                                            style: {"margin":"0","height":"24px","--padding-start":"0","--padding-end":"0"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                size: "small",
                                                slot: "icon-only",
                                                icon: _ctx.pencil
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          })
                                        ], 512), [
                                          [_vShow, !_ctx.isDemo && idx == _ctx.selectedPrograms.length]
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick", "disabled"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({length: 6}, (_, i) => i), (idx) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: `empty-${idx}`,
                                  class: _normalizeClass(["choice-item", _ctx.getBandClass(idx)]),
                                  lines: "full",
                                  onClick: ($event: any) => (idx == 0 ? _ctx.openABProgramDeckModal(null, false, true) : undefined),
                                  disabled: _ctx.isDemo || (idx == 0 ? false : true),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createElementVNode("p", _hoisted_38, [
                                            _createElementVNode("b", null, _toDisplayString(_ctx.getBandLabel(idx)), 1)
                                          ])
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_39, [
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            fill: "clear",
                                            style: {"margin":"0","height":"24px","--padding-start":"0","--padding-end":"0"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                size: "small",
                                                slot: "icon-only",
                                                icon: _ctx.pencil
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          })
                                        ], 512), [
                                          [_vShow, !_ctx.isDemo && idx == 0]
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick", "disabled"]))
                              }), 128))
                            ]))
                      ])
                    ])),
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createElementVNode("p", { style: {"line-height":"1"} }, [
                          _createElementVNode("small", null, "Disclaimer: The data presented is for reference purposes only. While we strive to provide up-to-date information, we do not guarantee their correctness, completeness, or timeliness. Users are advised to verify the details with the relevant educational authorities or institutions.")
                        ], -1)
                      ])),
                      _: 1,
                      __: [41]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 64))
}